export const HTTP_HEADERS = {
  // Http: "/front-api",
  Http: import.meta.env.VITE_API_BASE_URL || "/domeker-front-boot/front-api",
  // Ws: "/front-websocket"
  Ws: import.meta.env.VITE_API_BASE_WS || "/domeker-front-boot/front-websocket"
};
